import { useState } from 'react';
import { Link } from 'react-router';
import { homeProcessSteps, processConfig } from '../../config/process';
import { Reveal } from '../ui/Reveal';

export function ProcessSection() {
  const firstStepNumber = homeProcessSteps[0]?.number ?? '01';
  const [activeStepNumber, setActiveStepNumber] = useState(firstStepNumber);

  return (
    <section className="section process" id="process">
      <div className="shell home-process-layout">
        <Reveal className="home-process-layout__intro">
          <p className="eyebrow">Process</p>
          <h2>{processConfig.hero.title}</h2>
          <p className="home-process-layout__lead">{processConfig.hero.lead}</p>
          <Link className="text-link link-underline home-process-layout__link" to="/process">
            <span>View the full process</span>
            <span aria-hidden="true">→</span>
          </Link>
        </Reveal>

        <ol className="home-process-list" onMouseLeave={() => setActiveStepNumber(firstStepNumber)}>
          {homeProcessSteps.map((step, index) => (
            <li
              key={step.number}
              className="home-process-step"
              data-active={step.number === activeStepNumber ? 'true' : 'false'}
              onMouseEnter={() => setActiveStepNumber(step.number)}
            >
              <Reveal delay={index * 0.07}>
                <h3 className="home-process-step__heading">
                  <button
                    id={`home-process-trigger-${step.number}`}
                    type="button"
                    className="home-process-step__trigger"
                    aria-expanded={step.number === activeStepNumber}
                    aria-controls={`home-process-panel-${step.number}`}
                    onFocus={() => setActiveStepNumber(step.number)}
                    onClick={() => setActiveStepNumber(step.number)}
                  >
                    <span className="home-process-step__number">{step.number}</span>
                    {' '}
                    <span className="home-process-step__title">{step.title}</span>
                  </button>
                </h3>
                <div
                  id={`home-process-panel-${step.number}`}
                  className="home-process-step__panel"
                  aria-labelledby={`home-process-trigger-${step.number}`}
                  aria-hidden={step.number !== activeStepNumber}
                >
                  <div className="home-process-step__panel-clip">
                    <div className="home-process-step__panel-body">
                      <p>{step.description}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
